import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HeadphonesBatteryIcon(props: IconProps) {
    return <Icon {...props} iconKey={"headphones_battery"}/>
}
